import type { InvoiceTemplateType } from '~/api/invoiceTemplates/types';

import { useInvoiceTemplateFilters } from '~/api/invoiceTemplates';
import { ColumnIds } from '~/constants/table';
import { SearchParamKeys } from '~/constants/url';
import { includes } from '~/utils/arrays';
import { createTableSearchParams, parseAsIntegerWithValidation, parseAsStringWithValidation } from '~/utils/nuqs';

export const {
  useColumnFilters: useInvoiceTemplatesTableColumnFilters,
  useGlobalFilter: useInvoiceTemplatesTableGlobalFilter,
  usePaginationState: useInvoiceTemplatesTablePaginationState,
  useSorting: useInvoiceTemplatesTableSorting,
} = createTableSearchParams({
  columnFilters: {
    [SearchParamKeys.columnFilterClient]: ColumnIds.invoiceTemplatesClient,
    [SearchParamKeys.columnFilterBrand]: ColumnIds.invoiceTemplatesBrand,
    [SearchParamKeys.columnFilterTemplateType]: ColumnIds.invoiceTemplatesType,
  },
  defaultSorting: { id: ColumnIds.invoiceTemplatesTitle, desc: false },
  sortableColumnIds: [
    ColumnIds.invoiceTemplatesTitle,
    ColumnIds.invoiceTemplatesClient,
    ColumnIds.invoiceTemplatesTotal,
    ColumnIds.invoiceTemplatesType,
    ColumnIds.invoiceTemplatesNextInvoice,
  ],
  sortingIdPrefix: 'invoice_templates_',
  useColumnFilterParsers: () => {
    const { data: filters } = useInvoiceTemplateFilters();

    return {
      [SearchParamKeys.columnFilterClient]: parseAsIntegerWithValidation((value) => includes(filters.clientIds, value)),
      [SearchParamKeys.columnFilterBrand]: parseAsIntegerWithValidation((value) => includes(filters.brandIds, value)),
      [SearchParamKeys.columnFilterTemplateType]: parseAsStringWithValidation<InvoiceTemplateType>((value) =>
        includes(filters.types, value),
      ),
    };
  },
});
